import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ClientAccount, StyleGuide } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = StyleGuide[];

export const useStyleGuidesOptions = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query styleGuidesOptions {
      clientAccount {
        styleGuides {
          referenceId
          id
          name
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useStyleGuidesOptions'],
    queryFn: async () => {
      const response: ClientAccount = await client.request({
        data: {
          gql: graphql
        }
      });

      return response?.styleGuides ?? [];
    }
  });
};
